import { signal } from "@preact/signals-react";

const initialRequest = {
  userGuid: "",
  email: "",
  isPerquisiteBountyEnable: false,
  portalCD: "",
};

export const userStore = signal({
  userGuid: signal(""),
  email: signal(""),
  isPerquisiteBountyEnable: signal(false),
  portalCD: signal(""),
});

//export const userStore = signal("");
